class ApiAdapter {
  async load (customer, slug) {
    throw new Error('load method must be implemented')
  }

  async store (viewingRequest) {
    throw new Error('store method must be implemented')
  }

  adaptResponse (data) {
    throw new Error('adaptResponse method must be implemented')
  }
}

export default ApiAdapter
